import {Component, Injector, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";

@Component({
    selector: 'admin-report',
    templateUrl: './admin-report.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AdminReportComponent extends BasePageComponentDirective<any> implements OnInit {

    constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    override ngOnInit(): void {
        super.ngOnInit();

    }

    public override query(): void {
        throw new Error("Method not implemented.");
    }


}
